export const formatCampaignTitle = (campaignObj) => {
  let syntheticId = campaignObj?.parent_id ? campaignObj.synthetic_id : null;
  let campaignName = campaignObj?.campaign_display_name || campaignObj?.campaign_name || campaignObj?.campaignName;
  if (!campaignName) return '';
  if (!syntheticId || syntheticId === '-') return campaignName;
  return `${campaignName}:|${syntheticId}`;
};

export const numberToCurrencyString = (number) => {
  let num = number;
  if (typeof number === 'string') {
    num = Number(number);
    if (isNaN(num)) {
      return '';
    }
  }
  if (typeof num === 'number') {
    return num.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
  return '';
};

export const isValidNumber = (value) => !isNaN(value);

export const getLocalCurrency = (currencyName, budget) => {
  if (currencyName === 'USD') {
    return budget?.toLocaleString('en-US', {style: "currency", currency: "USD"});
  } else {
    return budget?.toLocaleString('en-US', {style: "currency", currency: currencyName});
  }
};

export const formatNumberToUSDCurrency = (number) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(number);
};

/**
 * Converts a camelCase string to Title Case with spaces.
 * Example: 'clientCode' -> 'Client Code', 'moAgencyId' -> 'Mo Agency Id'
 * @param {string} str - The camelCase string to convert.
 * @returns {string} - The formatted Title Case string.
 */
export const formatCamelCaseToTitleCase = (str) => {
  if (!str) return '';
  return str
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (char) => char.toUpperCase())
    .trim();
};
